import { render, staticRenderFns } from "./Mines.vue?vue&type=template&id=30e43036&scoped=true&"
import script from "./Mines.vue?vue&type=script&lang=js&"
export * from "./Mines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e43036",
  null
  
)

export default component.exports